import React from 'react';
import ReactDOM from 'react-dom';
import Demo from './Demo';

ReactDOM.render(<Demo />, document.querySelector('#content'));



/** WEBPACK FOOTER **
 ** ./demos/demo0-simple-transition/index.jsx
 **/